
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/livestreams",
      function () {
        return require("private-next-pages/livestreams.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/livestreams"])
      });
    }
  